import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { useTranslation } from 'react-i18next';

import { UploadedLoanDocumentType } from '../../../store/loanDocumentStore/types/UploadedLoanDocumentType';
import { locator } from '../../../testing/e2e-locator/locator';
import { filesize } from './filesize';

type LoanDocumentUploadedListProps = {
  uploadedDocuments: UploadedLoanDocumentType[];
};

export const LoanDocumentUploadedList = ({
  uploadedDocuments,
}: LoanDocumentUploadedListProps) => {
  const { t } = useTranslation();

  return (
    <>
      <h3 data-testid={locator.components.loanDocumentUploadedList.h3}>
        {t('LoanDocumentUploadPage.uploaded')}
      </h3>
      <ul
        className="loan-document-uploaded-list"
        data-testid={locator.components.loanDocumentUploadedList.root}
      >
        {uploadedDocuments.map((document: UploadedLoanDocumentType, index) => (
          <li
            data-testid={locator.components.loanDocumentUploadedList.getDocumentItem(
              index,
            )}
            key={document.name}
          >
            {document.url ? (
              <img alt={`Preview of ${document.name}`} src={document.url} />
            ) : (
              <PictureAsPdfIcon />
            )}
            <div>
              <p className="name">{document.name}</p>
              <p className="size">{filesize(document.size)}</p>
            </div>
          </li>
        ))}
      </ul>
    </>
  );
};
